import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { LegalInvestigationsClearanceLevelModel } from './legalClearanceLevel';

export const legalClearanceLevelValidator: ValidateJSModel<LegalInvestigationsClearanceLevelModel> = {
  Level: { presence: true, hasValue: true },
  Explanation: (value, attributes) => {
    if (attributes.Level && attributes.Level.value === 'Other') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
};
